import React from "react";
import "../styles/Sidebar.css";
import { 
  MdDashboard, MdOutlineManageAccounts, MdReport, MdSettings, MdLogout, MdPerson, 
  MdHome, MdAssignment, MdChecklist, MdNotifications, MdDirectionsWalk, MdWarning 
} from "react-icons/md"; // 🔹 Importando ícones corrigidos

const Sidebar = ({ onNavigate, onLogout, isSidebarOpen, toggleSidebar }) => {
  return (
    <>
      {/* Botão Hamburguer */}
      <button
        className={`menu-toggle ${isSidebarOpen ? "open" : ""}`}
        onClick={toggleSidebar}
        aria-label="Alternar Sidebar"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <nav>
          {/* Início */}
          <button className="menu-item" onClick={() => onNavigate("home")}>
            <MdHome className="sidebar-icon" /> Início
          </button>

          {/* Perfil */}
          <button className="menu-item" onClick={() => onNavigate("profile")}>
            <MdPerson className="sidebar-icon" /> Perfil
          </button>

          {/* Dashboard */}
          <button className="menu-item" onClick={() => onNavigate("dashboard")}>
            <MdDashboard className="sidebar-icon" /> Dashboard
          </button>

          {/* Relatórios */}
          <button className="menu-item" onClick={() => onNavigate("reports")}>
            <MdReport className="sidebar-icon" /> Relatórios
          </button>

          {/* Rondas e Inspeções - Ícone de patrulha */}
          <button className="menu-item" onClick={() => onNavigate("rondas")}>
            <MdDirectionsWalk className="sidebar-icon" /> Rondas e Inspeções
          </button>

          {/* Ocorrências - Ícone de alerta */}
          <button className="menu-item" onClick={() => onNavigate("ocorrencias")}>
            <MdWarning className="sidebar-icon" /> Ocorrências
          </button>

          {/* Gestão de Áreas e Ativos */}
          <button className="menu-item" onClick={() => onNavigate("areas-ativos")}>
            <MdAssignment className="sidebar-icon" /> Áreas e Ativos
          </button>

          {/* Checklist & Tarefas */}
          <button className="menu-item" onClick={() => onNavigate("checklist")}>
            <MdChecklist className="sidebar-icon" /> Checklist & Tarefas
          </button>

          {/* Notificações */}
          <button className="menu-item" onClick={() => onNavigate("notifications")}>
            <MdNotifications className="sidebar-icon" /> Notificações
          </button>

          {/* Assinatura & Pagamentos */}
          <button className="menu-item" onClick={() => onNavigate("SubscriptionManager")}>
            <MdOutlineManageAccounts className="sidebar-icon" /> Assinatura
          </button>

          {/* Configurações */}
          <button className="menu-item" onClick={() => onNavigate("Settings")}>
            <MdSettings className="sidebar-icon" /> Configurações
          </button>

          {/* Sair */}
          <button className="menu-item logout" onClick={onLogout}>
            <MdLogout className="sidebar-icon" /> Sair
          </button>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
